import React from 'react'
import PropTypes from 'prop-types'
import { polyglot, patientsDatabase } from '../../../../index'
import moment from 'moment'
import FormRenderer from '../../../common/FormRenderer/FormRenderer'
import SectionTitle from '../../../common/SectionTitle/SectionTitle'

import StagedFormInput from '../../../common/StagedFormInput/StagedFormInput'

export default class ConsultationInsertion extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      savedDataForAge: {}
    }
    this.getSavedDataForKey = this.getSavedDataForKey.bind(this)
    this.handleChange = this.handleChange.bind(this)
  }

  componentWillMount () {
    if (this.props.patientData) {
      if (this.props.patientData.consultations && this.props.patientData.consultations[this.props.consultationId]) {
        this.setState({
          savedDataForAge: this.props.patientData.consultations[this.props.consultationId]
        })
      }
    }
  }

  componentWillReceiveProps (props) {
    if (this.props.consultationId !== props.consultationId) {
      this.setState({
        savedDataForAge: {}
      })
    }
    if (props.patientData) {
      if (props.patientData.consultations && props.patientData.consultations[props.consultationId]) {
        this.setState({
          savedDataForAge: props.patientData.consultations[props.consultationId]
        })
      }
    }
  }

  getSavedDataForKey (key) {
    return this.state.savedDataForAge[key]
  }

  handleDataSubmit (data, key) {
    const consultation = {}
    if (this.props.consultationId !== undefined) {
      consultation['routineConsultationId'] = this.props.consultationId
    }
    consultation['date'] = moment().toString()
    consultation[key] = data
    if (this.state.pushedKey) {
      window.myLogger.info(JSON.stringify({message: 'Consultation Data Inserted', patient: this.props.patientKey, consultationKey: this.state.pushedKey, consultationData: data}))
      const consultationRef = patientsDatabase.child(this.props.patientKey)
        .child('data').child('consultations').child(this.state.pushedKey).child(key)
      consultationRef.set(data)
    } else {
      const consultationRef = patientsDatabase.child(this.props.patientKey)
        .child('data').child('consultations')
      const newRef = consultationRef.push(consultation)
      window.myLogger.info(JSON.stringify({message: 'Consultation Data Inserted', patient: this.props.patientKey, consultationKey: newRef.key, consultationData: data}))
      this.setState({
        pushedKey: newRef.key
      })
    }
  }

  getObservations () {
    const fields = []
    fields.push(this.getParameterForId('031'))
    return fields
  }

  renderObservations () {
    const fields = []
    fields.push(this.getParameterForId('031'))
    return <div>
      <SectionTitle title={polyglot.t('staticFields.consultation.observations.title')} size={'h3'} />
      <FormRenderer
        savedData={this.getSavedDataForKey('observations')}
        submitEnabled={false}
        dataKey={'observations'}
        saveData={this.handleDataSubmit.bind(this)}
        fields={fields} />
    </div>
  }

  getExaminedParameters () {
    const parameters = this.props.consultation['examinedParameters']
    const fields = []
    if (parameters) {
      Object.keys(parameters).forEach(key => {
        fields.push(this.getParameterForId(parameters[key]))
      })
    }
    return fields
  }

  renderParameters () {
    const parameters = this.props.consultation['examinedParameters']
    const fields = []
    if (parameters) {
      Object.keys(parameters).forEach(key => {
        fields.push(this.getParameterForId(parameters[key]))
      })
      return <div>
        <SectionTitle title={polyglot.t('staticFields.consultation.examinedParameters.title')} size={'h3'} />
        <FormRenderer
          handleChange={this.handleChange}
          submitEnabled={false}
          dataKey={'examinedParameters'}
          savedData={this.getSavedDataForKey('examinedParameters')}
          saveData={this.handleDataSubmit.bind(this)}
          fields={fields} />
      </div>
    }
  }

  getHealthParameters () {
    const parameters = this.props.consultation['healthParameters']
    const fields = []
    if (parameters) {
      Object.keys(parameters).forEach(key => {
        fields.push(this.getParameterForId(parameters[key]))
      })
    }
    return fields
  }
  renderHealthParameters () {
    const parameters = this.props.consultation['healthParameters']
    const fields = []
    Object.keys(parameters).forEach(key => {
      fields.push(this.getParameterForId(parameters[key]))
    })
    return <div>
      <SectionTitle title={polyglot.t('staticFields.consultation.healthParameters.title')} size={'h3'} />
      <FormRenderer
        handleChange={this.handleChange}
        submitEnabled={false}
        dataKey={'examinedParameters'}
        savedData={this.getSavedDataForKey('examinedParameters')}
        saveData={this.handleDataSubmit.bind(this)}
        fields={fields} />
    </div>
  }

  getPatientBmiIndex (weight, height) {
    if (weight && height) {
      const _weight = Number(weight)
      let _height = Number(height) / 100
      const bmi = _weight / (_height * _height)
      return (Math.round(bmi * 100) / 100).toString()
    } return null
  }

  handleChange (data, key) {
    const weight = data['weight']
    const height = data['height'] || data['length']
    data['bmi'] = this.getPatientBmiIndex(weight, height)
    const newState = this.state.savedDataForAge
    newState[key] = data
    this.setState({
      savedDataForAge: newState
    })
  }

  getTopics () {
    const topics = this.props.consultation['conversationTopics']
    const fields = []
    if (topics) {
      Object.keys(topics).forEach(key => {
        fields.push(this.getTopicsForId(topics[key]))
      })
    }
    return fields
  }

  renderTopics () {
    const topics = this.props.consultation['conversationTopics']
    const fields = []
    if (topics) {
      Object.keys(topics).forEach(key => {
        fields.push(this.getTopicsForId(topics[key]))
      })
      return <div>
        <SectionTitle title={polyglot.t('staticFields.consultation.conversationTopics.title')} size={'h3'} />
        <FormRenderer submitEnabled='false' dataKey={'conversationTopics'} savedData={this.getSavedDataForKey('conversationTopics')} handleChange={this.handleChange.bind(this)} saveData={this.handleDataSubmit.bind(this)} fields={fields} />
      </div>
    }
  }

  renderForm () {
    let fields = []
    if (Object.keys(this.getHealthParameters()).length > 0) {
      fields.push({fields: this.getHealthParameters(), title: 'staticFields.consultation.healthParameters.title', key: 'healthParameters'})
    }
    if (Object.keys(this.getExaminedParameters()).length > 0) {
      fields.push({fields: this.getExaminedParameters(), title: 'staticFields.consultation.examinedParameters.title', key: 'examinedParameters'})
    }
    if (Object.keys(this.getTopics()).length > 0) {
      fields.push({fields: this.getTopics(), title: 'staticFields.consultation.conversationTopics.title', key: 'conversationTopics'})
    }
    fields.push({fields: this.getObservations(), title: 'staticFields.consultation.observations.title', key: 'observations'})
    return <StagedFormInput
      expandInputFields
      redirectTo={this.props.toggleModal}
      savedData={this.state.savedDataForAge}
      handleDataChange={this.handleChange.bind(this)}
      handleDataSubmit={this.handleDataSubmit.bind(this)}
      data={fields} />
  }

  getParameterForId (id) {
    return this.props.configuration['analizedParameters'][id]
  }
  getTopicsForId (id) {
    return this.props.configuration['conversationTopics'][id]
  }

  render () {
    if (this.props.consultation) {
      return this.renderForm()
    } return <div>{polyglot.t('staticFields.commonFields.notFound')}</div>
  }
}

ConsultationInsertion.propTypes = {
  configuration: PropTypes.object.isRequired,
  consultation: PropTypes.object.isRequired,
  consultationId: PropTypes.number,
  patientKey: PropTypes.string.isRequired,
  patientData: PropTypes.object,
  toggleModal: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/components/general/Consultations/ConsultationInsertion/ConsultationInsertion.js